import React from 'react';
import Button from './ui/Button';
import { SITE } from '../constants/site';

function CTASection() {
  return (
    <section
      className="border-y border-optical-100 bg-gradient-to-br from-optical-50 via-white to-optical-50/80 py-16 md:py-20"
      aria-labelledby="cta-heading"
    >
      <div className="mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
        <h2 id="cta-heading" className="font-display text-3xl font-semibold text-slate-900 md:text-4xl">
          Ready for clearer, more comfortable vision?
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-slate-600">
          Stop by {SITE.businessName} for designer eyewear, contact lenses, and comprehensive eye care — our team is
          here to help you see and look your best.
        </p>
        <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:justify-center">
          <Button variant="primary" href="#store-info">
            Plan your visit
          </Button>
          <Button variant="secondary" href={`tel:${SITE.phone.tel}`}>
            Call {SITE.phone.display}
          </Button>
          <Button variant="secondary" href="#contact-us">
            Send a message
          </Button>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
